import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_STUDENT, CHANGE_STUDENT } from './constants';
import {
  loadStudentSuccess,
  loadStudentError,
  changeStudentSuccess,
  changeStudentError,
} from './actions';

import requestUtil from 'utils/request';
import requestWrapper from 'utils/requestWrapper';

export function* loadStudent(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { id } = action;

    // we get the campaigns linked to the student
    const itemData = yield requestWrapper('GET', `students/${id}`, '', currentUser.token);

    if (!id && !itemData) {
      yield put(loadStudentSuccess(false));
    } else {
      yield put(loadStudentSuccess(itemData));
    }
  } catch (error) {
    yield put(loadStudentError(error));
  }
}

// Update for Single Student
export function* changeStudent(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { itemData } = action;

    let changedItem = false,
      isNew = !itemData.hasOwnProperty('_id');

    if (isNew) {
      changedItem = yield requestWrapper(
        'POST',
        'students/new/',
        itemData,
        token,
      );
    } else {
      changedItem = yield requestWrapper('PATCH', `students/`, itemData, currentUser.token);
    }

    if (!changedItem) {
      yield put(changeStudentSuccess(false));
    } else {
      yield put(changeStudentSuccess(changedItem));
    }
  } catch (err) {
    yield put(changeStudentError(true));
  }
}

// Individual exports for testing
export default function* studentsDetailSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_STUDENT, loadStudent);
  yield takeLatest(CHANGE_STUDENT, changeStudent);
}
